import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { AtlassianLogo } from '@atlaskit/logo';
import errorImage from '../images/Error.svg';
import { useAnalyticsAnonymousId } from '../utilities/analytics/analytics-web-client';
import { isFedM } from '../utilities/env';
import FedrampUseIdProbe from '../utilities/debug/FedrampUseIdProbe';

interface Props {
  title: ReactNode;
  children?: ReactNode;
}

type BaseErrorPageProps = Props & { anonymousId?: string };

export default function ErrorPage({ title, children }: Props) {
  const anonymousId = useAnalyticsAnonymousId();

  return (
    <BaseErrorPage title={title} anonymousId={anonymousId}>
      {children}
      {isFedM() && <FedrampUseIdProbe context="error-page" />}
    </BaseErrorPage>
  );
}

export function BaseErrorPage({ title, anonymousId, children }: BaseErrorPageProps) {
  return (
    <ErrorContainer>
      <AtlassianLogo size="large" label="Atlassian" appearance="brand" />
      <div>
        <img src={errorImage} height="150" alt="" className="error-image" />
      </div>
      <h2 className="error-title">{title}</h2>
      {!!children && <div className="error-content">{children}</div>}

      <small className="error-diagnostic-details">
        <code>{anonymousId || '—'}</code>
      </small>
    </ErrorContainer>
  );
}

const ErrorContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 900px;
  padding: 100px 10px 0px 10px;
  text-align: center;

  .error-image {
    padding: 24px 0px;
  }

  .error-title {
    padding-top: 0px;
  }

  .error-content {
    padding-top: 16px;
  }

  .error-action {
    padding-top: 24px;
  }

  .error-diagnostic-details {
    display: block;
    padding-top: 24px;
  }
`;
